module.exports = __webpack_public_path__ + "img/arrow-up.eb3b26a4.svg";